const preferredTitleText = 'Meil on Sulle midagi öelda. Ja see on päris tähtis.';
const preferredTextHtml = 'Küpsised tagavad Sulle parima kasutajakogemuse ja aitavad mõista, milline sisu kõnetab Sinusuguseid loomasõpru kõige rohkem. '
    + 'Nii saab luua veel rohkem sellist sisu, mis toob rohkem inimesi loomade heaks tegutsema. '
    + '<strong>Otsuse teed Sina, ja saad seda igal ajal muuta. Palun tee oma valik, et jätkata veebilehe kasutamist.</strong>';

const replacementFunction = () => {
    document.getElementById('cc-nb-title').innerText = preferredTitleText;
    document.getElementById('cc-nb-text').innerHTML = preferredTextHtml;
};

document.addEventListener('cc_noticeBannerShown', () => {
    console.log('cc_noticeBannerShown');

    replacementFunction();

    setTimeout(replacementFunction, 0);
    setTimeout(replacementFunction, 10);
    setTimeout(replacementFunction, 100);
    setTimeout(replacementFunction, 500);
    setTimeout(replacementFunction, 1000);

    // const $text = $('.freeprivacypolicy-com---nb-interstitial-overlay #cc-nb-text');
    //
    // while ($text.html() !== preferredHtml) {
    //     $text.html(preferredHtml);
    //
    //     console.log('replacing');
    // }
});

// Vue renders the preference links after the widget has bound its own selector,
// so open the preferences center through event delegation instead.
document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.js-cookie-preferences');

    if (!trigger) {
        return;
    }

    event.preventDefault();

    if (window.cookieconsent && typeof window.cookieconsent.openPreferencesCenter === 'function') {
        window.cookieconsent.openPreferencesCenter();
    }
});
